import styled from 'styled-components';

export const StatisticStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .stat-value {
    font-weight: bold;
    font-size: 1.4rem;
    margin: 0 16px;
    opacity: 0.8;
    color: ${({ theme }) => theme.colors.primary};

    &::after {
      content: '|';
      position: relative;
      top: -2px;
      margin-left: 16px;
      font-size: 1.2rem;
      font-weight: normal;
      opacity: 0.2;
    }
  }

  .stat-text {
    max-width: 50%;
    order: 2;
    height: 100%;
    vertical-align: middle;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.text1};
  }
`;
